<template>
  <span>
    <storyblok-component v-if="story" :blok="story.content" />
  </span>
</template>

<script setup lang="ts">
import { storyKey } from "~/injection-symbols"

const route = useRoute()
const story = (await useSbStory(route.path.substring(1) || "/404")) as Ref<StoryblokPageStory>

provide(storyKey, story.value)
</script>
